<template>
  <div class="modal">
    <div class="animated fadeInDown modal-window">
      <div class="text">
        Ответ неверный
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'badAnswer'
}
</script>

<style scoped lang="scss">
  .modal {
    background: transparent;
    top: -700px;
    left: -22%;
    display: flex;
  }

  .modal-window {
    width: 400px;
    height: 50px;
    padding-top: 20px;
  }

  span.close {
    position: absolute;
    right: 30px;
    top: 20px;
    cursor: pointer;
  }

  .text {
    font-size: 18px;
    font-weight: 300;
  }

  .btn {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
    margin: 0 15px;
  }

  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  @-webkit-keyframes fadeInDown {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/BadAnswer.vue